exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".timezone[data-v-3631a371]{font-weight:700}.country[data-v-3631a371],.gmt-offset[data-v-3631a371],.timezone[data-v-3631a371]{font-size:14px;line-height:17px}.country[data-v-3631a371],.gmt-offset[data-v-3631a371]{font-weight:100}.wfh-btn[data-v-3631a371]{border-radius:6px;background-color:#5145ff;box-shadow:0 2px 4px 0 rgba(0,0,0,.09);color:#fff}", ""]);

// exports
